<div class="request form-frame">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">
    <h2
      class="form-frame__body-title">
      {{'REQUEST_PAGE.TITLE' | translate}}
    </h2>
    <p
      class="form-frame__body-description">
      {{'REQUEST_PAGE.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">

      <div
        [class.error]="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched"
        class="input-block">
        <input
          formControlName="emailFormControl"
          id="mail"
          class="input"
          type="email"
          placeholder=" ">
        <label
          for="mail"
          class="placeholder">
          {{'REQUEST_PAGE.E_MAIL' | translate}}
        </label>
        <ng-container *ngIf="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched">
          <span
            *ngIf="emailFormatError"
            class="input-block__error">
            {{'REQUEST_PAGE.EMAIL_INVALID' | translate}}
          </span>
          <span
            *ngIf="emailRequiredError"
            class="input-block__error">
            {{'REQUEST_PAGE.EMAIL_REQUIRED' | translate}}
          </span>
        </ng-container>
      </div>

      <button
        [disabled]="form.invalid"
        type="submit"
        class="btn btn-accent btn-send">
        {{'REQUEST_PAGE.SEND' | translate}}
      </button>
    </div>

  </form>

  <app-lang-select></app-lang-select>
</div>
